import React from 'react';
import cn from 'classnames';

import type { AddonContainerProps } from '../types';

const AddonContainer = ({ children, className }: AddonContainerProps) => {
  return children != null ? (
    <span className={cn('e-input__addon', className)}>{children}</span>
  ) : null;
};

const Prepend = ({ className, ...rest }: AddonContainerProps) => (
  <AddonContainer {...rest} className={cn('e-input__addon--prepend', className)} />
);

const Append = ({ className, ...rest }: AddonContainerProps) => (
  <AddonContainer {...rest} className={cn('e-input__addon--append', className)} />
);

const Addon = { Prepend, Append };

export default Addon;
